import React from "react";

import "./styles.css";

const Header = () => (
  <section className="root">
    <img alt="avatar" className="avatar" src="avatar.jpg" />
    <div>
      <h1>Arlen Yu </h1>
      <h2 className="title">SWE @ Instagram</h2>
    </div>
  </section>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js